import { CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect } from "react";

export const ApsSuccess = () => {
  useEffect(() => {
    console.log("ApsSuccess - OAuth callback received");
    console.log("Current URL:", window.location.href);
  }, [])

  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{ height: "100vh", width: "100%", textAlign: "center" }}
    >
      <Typography variant="h2">
        Integrated with Autodesk Platform Services successfully.
      </Typography>
      <Typography>Redirecting you to the application...</Typography>
      <Typography>
        If you are not redirected, please click{" "}
        <a href="/" style={{ color: "blue" }}>
          here
        </a>
        .
      </Typography>
      <CircularProgress />
    </Stack>
  );
};
